import {Subject} from 'rxjs';
import {BaseComponent} from '../base.component';

export class StepperControlsClass extends BaseComponent {

    doStepSubject = new Subject();

    isShowBackBtn: boolean = false;
    isShowNextBtn: boolean = true;

    activeStateIndex = 0;
    activeStateIsFirst = true;
    activeStateIsLast = true;

    onActiveSectionChange(state: any): void {
        this.isShowBackBtn = !state.isFirst;
        this.isShowNextBtn = !state.isLast;
        this.activeStateIndex = state.activeSection;
        this.activeStateIsFirst = state.isFirst;
        this.activeStateIsLast = state.isLast;
    }

    next(): void {
        this.doStepSubject.next(true);
    }

    back(): void {
        this.doStepSubject.next(false);
    }

}
